/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Modal;
function Modal() {
    return {
        template: "<div class=\"background\" ng-click=\"vm.isDismissable && vm.dismiss()\"/>\n               <div class=\"modal-container\"><ng-transclude/></div>",
        restrict: 'E',
        scope: {},
        controller: ModalController,
        controllerAs: 'vm',
        bindToController: true,
        transclude: true,
        link: function (scope, element) {
            scope.$watch('vm.zIndex', function (zIndex) {
                if (zIndex) {
                    element.css('z-index', zIndex);
                }
            });
        }
    };
}
var ModalController = (function () {
    function ModalController($scope, $element, $animate, $state, $q, $document, _, currentlyOpenModals, analytics) {
        this.$scope = $scope;
        this.$element = $element;
        this.$animate = $animate;
        this.$state = $state;
        this.$q = $q;
        this.$document = $document;
        this._ = _;
        this.currentlyOpenModals = currentlyOpenModals;
        this.analytics = analytics;
        this.name = '';
        this.isDismissable = true;
        // Cannot be opened when already open
        this.isOpen = false;
        // Once closed, cannot be reopened
        this.isClosed = false;
        // Cannot be opened or closed when already animating
        this.isAnimating = false;
        this.deferredReady = $q.defer();
        this.deferredClose = $q.defer();
        this.deferredDismissal = $q.defer();
        this.deferredSubmit = $q.defer();
    }
    ModalController.prototype.track = function (action) {
        var modalName = this._.kebabCase(this.name) || 'modal';
        this.analytics.track('Modal Change', {
            'State name': this.$state.$current.name + "." + modalName,
            'Action': action
        });
    };
    ModalController.prototype.setName = function (name) {
        this.name = name;
    };
    ModalController.prototype.open = function () {
        var _this = this;
        if (!this.isOpen && !this.isClosed) {
            this.isOpen = true;
            this.isAnimating = true;
            this.currentlyOpenModals.modalOpened(this);
            this.track('open');
            return this.$animate.enter(this.$element, this.$document.find('body')).finally(function () {
                _this.isAnimating = false;
            });
        }
        else {
            return this.$q.reject();
        }
    };
    ModalController.prototype.close = function (canTrack) {
        var _this = this;
        if (this.isOpen && !this.isClosed && !this.isAnimating) {
            this.isAnimating = true;
            this.currentlyOpenModals.modalClosed(this);
            return this.$animate.leave(this.$element).finally(function () {
                _this.isAnimating = false;
                _this.isClosed = true;
                _this.deferredClose.resolve();
                if (canTrack) {
                    _this.track('close');
                }
            });
        }
        else {
            return this.$q.reject();
        }
    };
    ModalController.prototype.dismiss = function () {
        var _this = this;
        if (this.isDismissable) {
            this.track('dismiss');
            return this.close().then(function () { return _this.deferredDismissal.resolve(); });
        }
        else {
            return this.$q.reject();
        }
    };
    ModalController.prototype.onClose = function (callback) {
        return this.deferredClose.promise.then(callback);
    };
    ModalController.prototype.onDismiss = function (callback) {
        return this.deferredDismissal.promise.then(callback);
    };
    ModalController.prototype.setDismissable = function (dismissable) {
        this.isDismissable = dismissable;
    };
    ModalController.prototype.getDismissable = function () {
        return this.isDismissable;
    };
    ModalController.prototype.decorateChild = function (child) {
        child.track = angular.bind(this, this.track);
        child.setName = angular.bind(this, this.setName);
        child.open = angular.bind(this, this.open);
        child.close = angular.bind(this, this.close);
        child.dismiss = angular.bind(this, this.dismiss);
        child.onClose = angular.bind(this, this.onClose);
        child.onDismiss = angular.bind(this, this.onDismiss);
        child.setDismissable = angular.bind(this, this.setDismissable);
        child.getDismissable = angular.bind(this, this.getDismissable);
        child.onSubmit = angular.bind(this, this.onSubmit);
        child.submitClick = angular.bind(this, this.submitClick);
    };
    ModalController.prototype.getReadyPromise = function () {
        return this.deferredReady.promise;
    };
    ModalController.prototype.resolveReadyPromise = function (controller) {
        if (controller === void 0) { controller = this; }
        this.deferredReady.resolve(controller);
    };
    ModalController.prototype.onSubmit = function (callback) {
        return this.deferredSubmit.promise.then(callback);
    };
    ModalController.prototype.submitClick = function () {
        this.deferredSubmit.resolve();
        this.track('submit');
        this.close();
    };
    return ModalController;
}());
ModalController.$inject = [
    '$scope', '$element', '$animate', '$state', '$q', '$document', 'lodash', 'currentlyOpenModals', 'analytics'
];



//////////////////
// WEBPACK FOOTER
// ./src/components/base/modal.directive.ts
// module id = 2
// module chunks = 0